import { Component, OnInit, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { currency } from 'app/constants/currency.constants';
import { DataService, HelperService } from 'app/services';
import { debounce, findIndex } from 'lodash';

@Component({
  selector: 'app-customer-credit-memo',
  templateUrl: './customer-credit-memo.component.html',
  styleUrls: ['./customer-credit-memo.component.scss'],
})
export class CustomerCreditMemoComponent implements OnInit {
  @Input() totalAvailableCredit: any;
  @Input('customerData')
  set customerData(data: any) {
    if (data && Object.keys(data).length > 0) {
      this.customer = data;
    }
  }
  @Input() estimate: any = {};
  @Input('creditMemos')
  set creditMemos(data: any) {
    this.creditMemo = [];
    if (data && Object.keys(data).length > 0) {
      this.creditMemo = data;
    }
  }
  @Input() totalCreditMemoRecords: number = 0;

  @Output() creditMemoUpdate = new EventEmitter();


  cols = [
    { field: 'code', header: 'Credit memo ID', class: 'memoId' },
    { field: 'status', header: 'Status', class: 'status' },
    { field: 'amount', header: 'Amount', class: 'amount' },
    { field: 'remainingAmount', header: 'Remaining Amount', class: 'rem-amount' },
  ];
  loading = false;
  customer: any = {};
  creditMemo: any = [];
  usd: string = currency.USD;
  isQboConnected: boolean = false;

  constructor(private dataService: DataService, private helperService: HelperService, private zone: NgZone) {
    this.isQboConnected = this.helperService.getCompany().qbo;
  }

  ngOnInit() {
    if (this.isQboConnected) {
      const index = findIndex(this.cols, { field: 'status' });

      if (this.cols[index + 1].field !== 'qboSyncStatus') {
        this.cols.splice(index + 1, 0, { field: 'qboSyncStatus', header: '	QBO status', class: 'status' });
      }
    }
  }

  
  onScroll(event) {
    this.zone.run(() => {
      const element = event.target;

      if (element.scrollHeight - element.scrollTop - element.clientHeight < 10) {
        if (this.creditMemo.length < this.totalCreditMemoRecords) {
          this.creditMemoUpdate.emit();
        }
      }
    });
  }

  openCreditMemoModal(rowData?) {
    const estimate = {
      ...this.estimate,
      customer: {
        customerId: this.customer._id,
        ...this.customer,
      },
    };
    if (rowData) {
      this.dataService.sendData(this.dataService.typeDialog('add-credit-payment', null, null, null, { estimate, memoId: rowData._id }));
    } else {
      this.dataService.sendData(this.dataService.typeDialog('add-credit-payment', null, null, null, { estimate }));
    }
  }
}
